import * as validationLib from "../../lib/validation";
import cn from "../../lib/classnames";
import React from "react";
import ReviewLabel from "../ReviewLabel";
import ReviewLink from "../ReviewLink";
import styles from "./ReviewDescription.module.css";
import textStyles from "../../styles/Text.module.css";

type Props = React.ComponentProps<"textarea"> & {
    id: string;
    reviewLabelText?: string;
    reviewLinkText?: string;
    reviewLinkHref?: string;
    value: string;
    placeholder?: string;
    message?: string;
    validationMessage?: string[];
};

const strings = {
    placeholder:
        "This is where you write your review. Explain what happened, and leave out offensive words. Keep your feedback honest, helpful, and constructive.",
};

function ReviewDescription(
    {
        id,
        onBlur,
        onChange,
        reviewLabelText,
        reviewLinkText,
        reviewLinkHref,
        value,
        className,
        message,
        placeholder = strings.placeholder,
        validationMessage,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLTextAreaElement>,
) {
    return (
        <div className={className}>
            {reviewLabelText ? (
                <ReviewLabel className={styles.reviewLabel} label={reviewLabelText} htmlFor={id} />
            ) : null}
            {reviewLinkText && reviewLinkHref ? (
                <ReviewLink
                    className={styles.reviewLink}
                    label={reviewLinkText}
                    href={reviewLinkHref}
                />
            ) : null}
            <textarea
                className={styles.input}
                ref={ref}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={placeholder}
                value={value}
                {...rest}
            />
            <div className={styles.allMessages}>
                {message ? <div>{message}</div> : null}
                {validationMessage && validationMessage.length ? (
                    <div className={cn(textStyles.inputError, styles.validation)}>
                        {validationLib.getDisplayString(validationMessage)}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default React.forwardRef<HTMLTextAreaElement, Props>(ReviewDescription);
